import type { QueryKey } from '@tanstack/react-query';

/**
 * Whether a cached query is about one workspace (spec 132): its key names the
 * workspace's id anywhere, as every per-workspace key in this app does
 * (`workspaceKeys.detail`, the generated `/api/workspaces/{id}/…` keys, the
 * feature key modules). Notification queries are left out: the stream keeps
 * those itself.
 */
export function isAboutWorkspace(
  queryKey: QueryKey,
  workspaceId: string,
): boolean {
  if (queryKey[0] === 'notifications') return false;
  return JSON.stringify(queryKey).includes(workspaceId);
}
